export default __webpack_public_path__ + "static/media/business_svc-lt.5a92eb3c.png";